export default {
	state: {
		outNotificationDetail: [],
		outNotificationData: {},
		outNotificationChartData: {},
		outNotificationList: []
	},

	getters: {

	},

	mutations: {
		setOutNotificationDetail(state, payload) {
			state.outNotificationDetail = payload;
		},
		setOutNotificationData(state, payload) {
			state.outNotificationData = payload;
		},
		setOutNotificationChartData(state, payload) {
			state.outNotificationChartData = payload;
		},
		setOutNotificationList(state, payload) {
			state.outNotificationList = payload;
		},
	},

	actions: {
		reqOutNotificationDetail( { commit }, params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/iprViolationRetrieveData/getwechatnoticelist",
					method: "get",
					params: params,
				}).then((res) => {
					if(res.status === '10000') {
						commit('setOutNotificationDetail', res.data.content);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
		reqOutNotification( { commit }, params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/iprViolationRetrieveData/getlinkstatistical",
					method: "get",
					params: params,
				}).then((res) => {
					if(res.status === '10000') {
						commit('setOutNotificationData', res.data.mapA);
						commit('setOutNotificationChartData', res.data.mapB);
						r(res.data.mapB);
					}
				}).catch(() => {
					j();
				})
			})
		},
		reqOutNotificationList( { commit }, params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/iprViolationRetrieveData/getShoplist",
					method: "get",
					params: params,
				}).then((res) => {
					if(res.status === '10000') {
						commit('setOutNotificationList', res.data.content);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
	},
}
